<template>
  <div id="homePage">
    <div class="header">
      <div class="carousel">
        <el-carousel :interval="6000" indicator-position="none" type="card" height="300px">
          <el-carousel-item v-for="item in srcs" :key="item">
            <img :src="item" style="width: 100%;;" alt="">
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="todyMeets">
        <el-card style="height:300px;">
        <div slot="header" class="clearfix">
          <span>会议列表</span>

        </div>
        <div
          v-for="(mt,index) in meetingList"
          :key="mt.id"
          :title="mt.estimate_start_time.split(' ').slice(1)[0].split(':')[0]+' : '+ mt.estimate_start_time.split(' ').slice(1)[0].split(':')[1]+' '+mt.meeting_subject"
          class="text-item"
          @click="toMeetingSub(mt)">
          <p class="msg">{{ index+1 }}.
            {{ mt.estimate_start_time.split(' ').slice(1)[0].split(':')[0] }}:{{ mt.estimate_start_time.split(' ').slice(1)[0].split(':')[1] }}
            -
            {{ mt.estimate_end_time.split(' ').slice(1)[0].split(':')[0] }}:{{ mt.estimate_end_time.split(' ').slice(1)[0].split(':')[1] }}
            {{ mt.meeting_subject }}</p>
          <span class="status">{{ ['(已预约)', '(进行中)', '(已结束)', '(未进行)', '(已取消)', '(决议处理中)', '(会议待评分)', '(已完成)'][mt.meeting_status] }}</span>
        </div>
      </el-card>
      </div>
    </div>
    <div class="content">
      <div class="dataSelect">
        <el-radio-group v-model="dataType" size="small" class="radio">
          <el-radio-button label="year">年历</el-radio-button>
          <el-radio-button label="month">月历</el-radio-button>
        </el-radio-group>
        <el-date-picker v-model="month" type="month" @change="handleMonthChange" v-if="dataType==='month'" size="small" placeholder="月份" class="picker" :clearable="false"></el-date-picker>
        <el-date-picker v-model="year" type="year" value-format="yyyy" @change="getMeetingScheduleData" v-else size="small" placeholder="年份" class="picker" :clearable="false"></el-date-picker>
        <div class="depart">
          <span class="title">部门：</span>
          <el-cascader ref="cascader" :options="departData" v-model="udId" @change="handleDeptChange" :props="{checkStrictly: true, value: 'udId', label: 'udName'}" clearable size="small"></el-cascader>
        </div>
        <div class="user">
          <span class="title">用户：</span>
          <el-select v-model="user" filterable placeholder="支持过滤选择" size="small" clearable>
            <el-option v-for="item in userList" :key="item.id" :value="item.value" :label="item.label"></el-option>
          </el-select>
        </div>
        <el-button class="btn" size="small" type="primary" @click="getMeetingScheduleData">查询</el-button>
      </div>
      <div class="calendarPanel" v-if="dataType==='year'">
        <!-- 使用轮播，三个会议一组 -->
        <el-carousel v-loading="isLoading" element-loading-text="数据加载中..." indicator-position="none" :initial-index="initialIndex" arrow="always" :autoplay="false" style="height: 440px;">
          <el-carousel-item v-for="i in 4" :key="i">
            <div class="carouselItem">
              <div class="calendar" :class="{'isNow': item.isNow}" v-for="item in calendar.slice((i-1)*3, i*3)" :key="item.month">
                <template v-if="item.isNow">
                  <el-calendar :key="item.month + 1" v-model="item.one" class="nowMonth">
                    <template slot="dateCell" slot-scope="{date, data}">
                      <div class="selectData" @click="calendarChange(date, item.firstDay)">
                        <p :class="data.isSelected ? 'is-selected' : ''">
                          <span :class="data.isSelected ? 'selectCalendar' : 'dontSelect'">{{ data.day.split('-').slice(2).join('.') }}</span>
                        </p>
                        <div v-for="(item1, index) in item.meetings" :key="index">
                          <div v-if="(item1.months).indexOf(data.day.split('-').slice(1)[0])!=-1">
                            <div v-if="(item1.days).indexOf(data.day.split('-').slice(2).join('-'))!=-1">
                                <div class="is-selected2">
                                  <div class="meetsShow">
                                    <template v-if="item1.meetings.length<3">
                                      <div class="meet-item ellipsis" :title="meet.meeting_subject" v-for="(meet,index1) in item1.meetings"  :key="index1+meet.meeting_subject">{{ meet.meeting_subject }}</div>
                                    </template>
                                    <template v-else>
                                      <div class="meet-item ellipsis" :title="item1.meetings[0].meeting_subject">{{ item1.meetings[0].meeting_subject }}</div>
                                      <div class="meet-item ellipsis" :title="item1.meetings.slice(1).map(i => i.meeting_subject).join('\n')">还有{{item1.meetings.length-1}}个日程</div>
                                    </template>
                                  </div>
                                </div>
                            </div>
                            <div v-else />
                          </div>
                          <div v-else />
                        </div>
                      </div>
                    </template>
                  </el-calendar>
                </template>
                <template v-else>
                  <el-calendar  :key="item.month + 2" v-model="item.one">
                    <template slot="dateCell" slot-scope="{date, data}">
                      <div class="selectData" @click="calendarChange(date, item.firstDay)">
                        <p :class="data.isSelected ? 'is-selected' : ''">
                          <span :class="data.isSelected ? 'selectCalendar' : 'dontSelect'">{{ data.day.split('-').slice(2).join('.') }}</span>
                        </p>
                        <div v-for="(item1, index) in item.meetings" :key="index">
                          <div v-if="(item1.months).indexOf(data.day.split('-').slice(1)[0])!=-1">
                            <div v-if="(item1.days).indexOf(data.day.split('-').slice(2).join('-'))!=-1">
                                <div class="is-selected2">
                                  <div class="meetsShow">
                                    <template v-if="item1.meetings.length<3">
                                      <div class="meet-item ellipsis" :title="meet.meeting_subject" v-for="(meet,index1) in item1.meetings" :key="index1+meet.meeting_subject">{{ meet.meeting_subject }}</div>
                                    </template>
                                    <template v-else>
                                      <div class="meet-item ellipsis" :title="item1.meetings[0].meeting_subject">{{ item1.meetings[0].meeting_subject }}</div>
                                      <div class="meet-item ellipsis" :title="item1.meetings.slice(1).map(i => i.meeting_subject).join('\n')">还有{{item1.meetings.length-1}}个日程</div>
                                    </template>
                                  </div>
                                </div>
                            </div>
                            <div v-else />
                          </div>
                          <div v-else />
                        </div>
                      </div>
                    </template>
                  </el-calendar>
                </template>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
        <!-- <div v-else class="isLoading">
          <span>数据加载中</span>
        </div> -->
      </div>
      <div v-else class="calendarPanel">
        <div class="carouselItem">
          <el-calendar key="carouselItem_month" v-loading="isLoading" element-loading-text="数据加载中..." v-model="selectDate" style="width: 600px;border:1px solid #afacac;border-radius:6px;">
            <template slot="dateCell" slot-scope="{date, data}">
              <div class="selectData" @click="calendarChange(date, '1')">
                <p :class="data.isSelected ? 'is-selected' : ''">
                  <span :class="data.isSelected ? 'selectCalendar' : 'dontSelect'">{{ data.day.split('-').slice(2).join('.') }}</span>
                </p>
                <div v-for="(item1, index) in calendarData" :key="index">
                  <div v-if="(item1.months).indexOf(data.day.split('-').slice(1)[0])!=-1">
                    <div v-if="(item1.days).indexOf(data.day.split('-').slice(2).join('-'))!=-1">
                        <div class="is-selected2">
                          <div class="meetsShow">
                            <template v-if="item1.meetings.length<3">
                              <div class="meet-item ellipsis" :title="meet.meeting_subject" v-for="(meet,index1) in item1.meetings" :key="index1+meet.meeting_subject">{{ meet.meeting_subject }}</div>
                            </template>
                            <template v-else>
                              <div class="meet-item ellipsis" :title="item1.meetings[0].meeting_subject">{{ item1.meetings[0].meeting_subject }}</div>
                              <div class="meet-item ellipsis" :title="item1.meetings.slice(1).map(i => i.meeting_subject).join('\n')">还有{{item1.meetings.length-1}}个日程</div>
                            </template>
                          </div>
                        </div>
                    </div>
                    <div v-else />
                  </div>
                  <div v-else />
                </div>
              </div>
            </template>
          </el-calendar>
        </div>
      </div>
    </div>
    <el-dialog
      v-if="this.$store.state.once.count <= 1"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      title="温馨提示"
      width="460px">
      <div>
        <p style="line-height: 30px;font-size: 20px;">欢迎使用会议管理系统！页面右上角有此系统的详细操作手册，使用过程中遇到问题可查阅！(●'◡'●)</p>
        <p style="line-height: 30px;font-size: 20px;">亦可咨询会议秘书哦！页面右上角有秘书窗口，请查看！(●'◡'●)</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import {
  // tasksearch,
  meetingsearch
} from '@/api/seedetails'
import {
  // searchTask,
  getMeetingSchedule
} from '@/api/morningMeeting'
// import { getDeptTree } from '@/utils/index'
import {
  getUserInfoByName
  // getUserInfoById
} from '@/api/login'
import dayjs from 'dayjs'
// import { Progress } from 'element-ui'
// import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      dataType: 'month',
      month: '',
      year: dayjs().format('YYYY'),
      depart: '',
      // 部门负责人或者直接选择了人员
      user: '',
      count: 1,
      // last_page: 1,
      // taskList: [],
      selectDate: new Date(),
      meetingList: [],
      calendarData: [], // 日历的每月会议数据格式化后
      // morningTaskList: [],
      dialogVisible: true,
      isLoading: false,
      srcs: [ // 会议室图片
        'https://apimeeting.suntekcorps.com/uploads/20191210/ee7c00f0694c373667b01420ce744126.jpg',
        'https://apimeeting.suntekcorps.com/uploads/20191210/0a064693348080ed9c099f1b4f8e26bc.jpg',
        'https://apimeeting.suntekcorps.com/uploads/20191210/525ba6eba8bbb656b78b9e0c4efebe79.jpg',
        'https://apimeeting.suntekcorps.com/uploads/20191210/5f413e6c4d8e744a9c853d2b062fdd9f.jpg',
        'https://apimeeting.suntekcorps.com/uploads/20191210/d00f6483f5d483a0ccc172351bd2193c.jpg'
      ],
      calendar: [], // 12个月的日历,过滤了早晚会的数据
      calendarAll: [], // 12个月的日历,包含了早晚会的数据
      initialIndex: Math.floor((new Date().getMonth()) / 3), // 初始化显示的月份
      udId: [], // 部门id
      userList: [] // 用户列表
    }
  },
  computed: {
    departData() {
      // return this.$store.getters.departTree
      // 当前登陆人的部门列表(boss 为全部)
      // if (this.$store.getters.username === 'PZWG0000') {
      //   return this.$store.getters.departTree
      // }
      // return getDeptTree(this.$store.getters.departmentId, this.$store.getters.departTree)
      // 暂时都返回所有部门
      return this.$store.getters.departTree
    }
  },
  created() {
    // this.getMyTask()
    // this.getMorning()
    // 获取当前年
    // this.year = (new Date().getMonth()).toString()
    // const todaydate = new Date()
    // this.month = todaydate.getMonth() + 1 < 10 ? todaydate.getFullYear() + '-0' + (todaydate.getMonth() + 1) : todaydate.getFullYear() + '-' + (todaydate.getMonth() + 1)
    this.month = dayjs(new Date()).format('YYYY-MM')
    this.calendarChange(new Date())
    // this.getMonthMeeting(todaydate);
  },
  watch: {
    dataType(val) {
      this.meetingList = []
      if (val === 'month') {
        // const y = new Date().getFullYear()
        // const m = new Date().getMonth() + 1
        // this.month = m < 10 ? y + '-0' + m : y + '-' + m
        this.month = dayjs(new Date()).format('YYYY-MM')
      } else {
        this.month = ''
        this.selectDate = dayjs(new Date()).format('YYYY-MM-DD')
      }
      this.getMeetingScheduleData()
    }
  },
  mounted() {
    this.$store.dispatch('ADD_COUNT')// 执行一次计数，出现一次弹窗就够了
    if (this.$store.getters.departTree.length === 0) {
      this.$store.dispatch('getDepartData')
    }
    this.getMeetingScheduleData()
    // if (this.$store.getters.username === 'PZWG0000') {
    //   const params = {
    //     ucId: process.env.VUE_APP_COMPANY_ID,
    //     page: 1,
    //     pageSize: 9999
    //   }
    //   // 如果是老板，开始的时候就获取所有人
    //   this.getUserList(params, -1)
    // }
    const params = {
      ucId: process.env.VUE_APP_COMPANY_ID,
      page: 1,
      pageSize: 9999
    }
    // 如果是老板，开始的时候就获取所有人
    this.getUserList(params, -1)
  },
  methods: {
    // 查询会议日历
    // 不传部门和人、则查登录人的会议日程
    getMeetingScheduleData() {
      console.log(333, this.userList, this.user + '333')
      const params = {
        departmentId: this.udId.length > 0 ? this.udId[this.udId.length - 1] : null,
        year: this.dataType === 'year' ? this.year : '',
        month: this.month ? dayjs(this.month).format('YYYY-MM') : '',
        workCode: this.user,
        userId: ''
      }
      if (this.user) {
        params.userId = this.userList.find(item => item.value === this.user)?.id
      }
      this.calendar = []
      this.calendarData = []
      this.isLoading = true
      getMeetingSchedule(params).then(res => {
        console.log('aaaaaaaaaa', res)
        this.calendarAll = this.meetFormate(res.data)
        this.calendar = this.meetFormate(res.data, true)
        if (this.dataType === 'year') {

        } else {
          this.calendarData = this.calendar.filter(per => per.isNow)[0].meetings
        }
        this.isLoading = false
        console.log('数据111111111', this.calendar, this.calendarAll)
      }).catch(() => {
        this.isLoading = false
      })
    },
    toSeeDetails(id) { // 跳转到任务详情
      this.$router.push({ name: 'seeDetails', query: { id: id }})
    },
    toMorningDetails(id) { // 跳转到任务
      this.$router.push({ name: 'morningDetails', query: { id: id }})
    },
    toMyTaskList() { // 跳转到任务
      this.$router.push({ name: 'myTaskList' })
    },
    toMorningTask() { // 跳转到任务
      this.$router.push({ name: 'morningTask' })
    },
    // 点击切换日历，直接从数据过滤(当查看登陆人自己的会议时，显示早晚会)
    calendarChange(date, val) {
      console.log('date', dayjs(date).format('YYYY-MM-DD'))
      console.log('val', val)
      console.log('this.month', this.month)
      console.log('this.selectDate', this.selectDate)
      console.log('this.calendar', this.calendar)
      // 如果在当前日历面板点击了其他月份的日期，要特殊处理，因为日历面板的数据是当前月份的
      // 如：在4月份的面板上点击3月份的日期
      if (val) {
        if (val === '1' && dayjs(this.month).format('YYYY-MM') !== dayjs(date).format('YYYY-MM')) { // 月历
          console.log('月历')
          // this.calendar = []
          // this.calendarData = []
          this.month = dayjs(date).format('YYYY-MM')
          this.getMeetingScheduleData()
          return
        } else if (val !== '1' && val !== (dayjs(date).format('YYYY-MM') + '-01')) { // 年历
          console.log('年历')
          // this.calendar = []
          return
        }
      }
      if (this.calendar.length === 0) {
        // 获取当月的会议
        const fmt = 'yyyy-MM-dd'
        const dd = this.dateFtt(fmt, date)
        const form = {
          estimate_start_time: dd + ' ' + '00:00:00',
          estimate_end_time: dd + ' ' + '23:59:59',
          own_meeting: 1
        }
        this.meetingList = []
        // 当天的大杂会
        meetingsearch(form).then(res => {
          if (res.data) {
            this.meetingList = this.meetingList.concat(res.data.meetings)
          } else {
            // this.meetingList = []
          }
        })

        const obj = JSON.parse(JSON.stringify(form))
        obj.type_id = 7
        obj.own_meeting = 1
        // 当天的早晚会
        meetingsearch(obj).then(res => {
          if (res.data) {
            this.meetingList = this.meetingList.concat(res.data.meetings)
          } else {
            // this.meetingList = [];
          }
        })
      } else {
        // debugger
        const filterArr = (this.udId.length > 0 || this.user) ? this.calendar : this.calendarAll
        const nowMonth = dayjs(date).format('YYYY-MM')
        console.log(this.calendar, nowMonth)
        const nowMonthList = filterArr.filter(month => {
          return dayjs(month.one).format('YYYY-MM') === nowMonth
        })[0].meetings
        const nowDay = dayjs(date).format('DD')
        const nowDayList = nowMonthList.filter(day => {
          return day.days === nowDay
        })
        // 过滤早晚会
        // if (this.udId.length > 0 || this.user) {
        //   this.meetingList = nowDayList.length > 0 ? nowDayList[0].meetings.filter(item => item.meeting_type_id !== 7) : []
        // } else {
        //   this.meetingList = nowDayList.length > 0 ? nowDayList[0].meetings : []
        // }
        this.meetingList = nowDayList.length > 0 ? nowDayList[0].meetings : []
        console.log('是否初始', this.meetingList)
      }
    },
    // 日历每月有会议的颜色改变
    // getMonthMeeting(date) { // 获取一个月内的会议
    //   if (date) {
    //     console.log()
    //   } else {
    //     date = new Date()
    //   }

    //   const fmt = 'yyyy'
    //   const fmt2 = 'MM'
    //   const yy = this.dateFtt(fmt, date)

    //   const mm = this.dateFtt(fmt2, date)
    //   let mmNext = ''
    //   let yySecond = ''
    //   // 如果是12月下一年份月份改（求一个月的会议）
    //   if (mm === '12') {
    //     mmNext = '01'
    //     yySecond = Number(yy) + 1
    //   } else {
    //     mmNext = Number(this.dateFtt(fmt2, date)) + 1
    //     if (mmNext < 10) { // 2020-2-01 00:00:00"
    //       mmNext = '0' + mmNext// "2020-02-01 00:00:00"
    //     }
    //     yySecond = yy
    //   }

    //   const form = {
    //     estimate_start_time: yy + '-' + mm + '-01' + ' ' + '00:00:00',
    //     estimate_end_time: yySecond + '-' + mmNext + '-01' + ' ' + '00:00:00',
    //     own_meeting: 1
    //   }

    //   meetingsearch(form).then(res => {
    //     if (res.data.meetings) {
    //       const obj = {
    //         month: Number(mm),
    //         meetings: res.data.meetings
    //       }
    //       console.log([obj])
    //       this.calendarData = this.meetFormate([obj])[0].meetings
    //       console.log('this.calendarData', this.calendarData)
    //     } else {
    //       this.calendarData = []
    //     }
    //   }).catch(() => { })
    // },

    // 月份会议数据组装，处理当天有多个会议的情况, type: true 过滤掉早晚会(查看自己的会议日程时才显示早晚会)
    meetFormate(meetings, type) {
      const arr = []
      const year = this.dataType === 'year' ? this.year : new Date().getFullYear()
      const nowMonth = this.month ? dayjs(this.month).format('MM') : dayjs(new Date()).format('MM')
      meetings.forEach(item => {
        const firstDay = year + '-' + (Number(item.month) < 10 ? '0' + Number(item.month) : Number(item.month)) + '-01'
        const object = {
          one: firstDay, // 当月1号，用来初始化日历
          // one: dayjs(item.month).format('YYYY-MM') + '-01', // 当月1号，用来初始化日历
          firstDay,
          isNow: this.dataType === 'year' ? dayjs(this.year + item.month).format('YYYY-MM') === dayjs().format('YYYY-MM') : Number(item.month) === Number(nowMonth), // 是否是当前月
          meetings: []
        }
        // 会议按时间排序
        const allMeets = type ? item.meetings.filter(item => item.meeting_type_id !== 7) : item.meetings
        const meets = allMeets.sort((a, b) => {
          return Number(a.estimate_start_time.split(' ')[0].replace(/-/g, '') + '' + a.estimate_start_time.split(' ')[1].replace(/:/g, '')) - Number(b.estimate_start_time.split(' ')[0].replace(/-/g, '') + '' + b.estimate_start_time.split(' ')[1].replace(/:/g, ''))
        })
        // 会议按天分组
        const group = meets.reduce((r, a) => {
          r[a.estimate_start_time.split(' ')[0]] = [...r[a.estimate_start_time.split(' ')[0]] || [], a]
          return r
        }, {})
        // console.log('group', group)
        Object.keys(group).forEach(key => {
          object.meetings.push({
            months: key.split('-')[1],
            days: key.split('-')[2],
            meetings: group[key]
          })
        })
        arr.push(object)
      })
      return arr
    },
    // 格式化时间
    dateFtt(fmt, date) { // author: meizz
      var o = {
        'M+': date.getMonth() + 1, // 月份
        'd+': date.getDate(), // 日
        'h+': date.getHours(), // 小时
        'm+': date.getMinutes(), // 分
        's+': date.getSeconds(), // 秒
        'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
        S: date.getMilliseconds() // 毫秒
      }
      if (/(y+)/.test(fmt)) { fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length)) }
      for (var k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) { fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length))) }
      }
      return fmt
    },
    toMeetingSub(item) {
      console.log(333, this.meetingList, item)
      if (!item.show_auth) {
        this.$message({
          message: '您没有权限查看该会议',
          type: 'warning'
        })
        return
      }
      const url = this.$router.resolve({
        path: item.meeting_type_id === 7 ? '/morningList/morningDetails' : '/conferenceStatusTask/seeDetails',
        query: { id: item.id }
      })
      window.open(url.href, '_blank')
    },
    handleMonthChange() {
      console.log('month', this.month)
      const date = new Date(this.month)
      this.selectDate = date.getFullYear() + '-' + (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)
      // this.getMonthMeeting(new Date(this.month))
      this.getMeetingScheduleData()
    },
    handleDeptChange() {
      // console.log('dept', this.udId)
      this.user = ''
      if (this.udId.length === 0) {
        // 在部门选择框清空时，如果是老板，获取所有人；否则清空人员列表
        // if (this.$store.getters.username === 'PZWG0000') {
        //   const params = {
        //     ucId: process.env.VUE_APP_COMPANY_ID,
        //     page: 1,
        //     pageSize: 9999
        //   }
        //   this.getUserList(params, -1)
        // } else {
        //   this.userList = []
        // }
        // 都改为获取所有人
        const params = {
          ucId: process.env.VUE_APP_COMPANY_ID,
          page: 1,
          pageSize: 9999
        }
        this.getUserList(params, -1)
        this.getMeetingScheduleData()
      } else {
        const node = this.$refs.cascader.getCheckedNodes()
        const deptManager = Number(node[0].data.bumfzr) // 部门负责人userId
        console.log('node', node, node[0].data)
        const params = { udId: this.udId[this.udId.length - 1] || 0, pageSize: 9999 }
        this.getUserList(params, deptManager)
        // getUserInfoByName(params).then(res => {
        //   this.userList = res.data.list.map(item => {
        //     return {
        //       value: item.username,
        //       label: item.name,
        //       id: item.userId
        //     }
        //   })
        //   // 因为部门负责人可能不在部门人员列表中
        //   const arr = this.userList.filter(item => item.id === deptManager)
        //   this.user = arr.length > 0 ? arr[0].value : ''
        //   console.log(this.userList, this.user)
        //   this.getMeetingScheduleData()
        // }).catch(() => {
        //   this.userList = []
        //   this.getMeetingScheduleData()
        // })
      }
    },
    // 获取人员列表，老板不选部门，则可以选择所有人，选择部门，则只能选择部门人员
    getUserList(params, deptManager) {
      getUserInfoByName(params).then(res => {
        this.userList = res.data.list.map(item => {
          return {
            value: item.username,
            label: `${item.name}(${item.username})`,
            id: item.userId
          }
        })
        // 因为部门负责人可能不在部门人员列表中
        const arr = this.userList.filter(item => item.id === deptManager)
        this.user = arr.length > 0 ? arr[0].value : ''
        console.log('333this.userList, this.user', this.userList, this.user)
        this.getMeetingScheduleData()
      }).catch(() => {
        this.userList = []
        this.getMeetingScheduleData()
      })
    }
  }
}
</script>

<style scoped lang="scss">
  .el-aside {
    /* background-color: #D3DCE6; */
    color: #333;
    padding-left: 10px;
    /* text-align: center; */
  }

  .el-main {
    /* background-color: #f8f8f8; */
    color: #333;
    /* text-align: center; */
    padding: 0px 5px 10px 0px;
    overflow: auto / scroll;
    min-width: 600px;
  }

  .green {
    background-color: rgb(86, 222, 115);
  }

  .red {
    background-color: #FD2677;
  }

  .orange {
    background-color: orange;
  }

  .purple {
    background-color: #CB6EFE;
  }

  .blue {
    background-color: #6871E3;
  }

  .top .middle.green {
    height: 240px;
    padding: 50px 0;
  }

  .middle.green p {
    margin: 0;
    padding: 0;
    line-height: 40px;
    font-size: 30px;
    font-weight: bold;
    font-family: cursive
  }

  .el-main>div {
    margin-bottom: 15px;
  }
  .list {
    /* width: 100%; */
    padding: 0;
    margin-left: 14px;
    list-style: circle;
    /* list-style-image:url("favicon.jpg"); */
  }

  .list-item {
    font-size: 14px;
    height: 30px;
    line-height: 30px;
    color: #6e6b6b;
    /* text-align: left; */
    white-space: nowrap;
    text-overflow: ellipsis;
    padding-left: 10px;
    width: 95%;
    overflow: hidden;
    cursor: pointer;
  }

  .overTime {
    color: #D15D5D;
  }

  .list-item b {
    width: 20px;
    text-align: right;
    float: left;
  }

  .list-item .name1 {
    float: left;
    width: calc(100% - 150px);
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .list-item .time1 {
    width: 120px;
    float: right;
  }

  /* .list-item:hover {

    color: brown;
    cursor: pointer;
    font-size: 16px;
    box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.3);
    height: 40px;
    line-height: 40px;
    border-radius: 5px;
    margin-left: 5px;
    animation: LRightYY 1s ease-in-out 1;
  } */

  @keyframes LRightYY {
    16.65% {
      -webkit-transform: translateX(8px);
      transform: translateX(8px);
    }

    33.3% {
      -webkit-transform: translateX(-6px);
      transform: translateX(-6px);
    }

    49.95% {
      -webkit-transform: translateX(4px);
      transform: translateX(4px);
    }

    66.6% {
      -webkit-transform: translateX(-2px);
      transform: translateX(-2px);
    }

    83.25% {
      -webkit-transform: translateX(1px);
      transform: translateX(1px);
    }

    100% {
      -webkit-transform: translateX(0);
      transform: translateX(0);
    }
  }

  .dontSelect {
    font-size: 14px;
    font-weight: 600;
  }

  .selectCalendar {
    display: inline-block;
    width: 24px;
    height: 24px;
    line-height: 24px;
    text-align: center;
    border-radius: 50%;
    background-color: #56de73;
    color: #fff;
    font-weight: bold;
    box-shadow: 2px 2px 20px;
  }

  .height255 {
    height: 250px;
  }

  .selectData {
    width: 100%;
    height: 100%;
    text-align: center;
    position: relative;

    p {
      // color: #1989FA;
      z-index: 20;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
    }
  }

  .text-item {
    cursor: pointer;
    padding-right: 85px;
    height: 30px;
    line-height: 30px;
    position: relative;
    font-size: 14px;
  }

  .text-item .msg {
    width: 100%;
    margin: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .text-item .status {
    width: 90px;
    text-align: right;
    font-weight: bold;
    line-height: 30px;
    position: absolute;
    top: 0;
    right: 0px;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }

  .calendar-day {
    text-align: center;
    color: #202535;
    line-height: 30px;
    font-size: 12px;
  }

  .is-selected2 {
    /* color: #F8A535; */
    color: #fff;
    font-size: 10px;
    /* margin-top: 0px; */
    /* width: 60px;
    height: 72px;
    line-height: 70px; */
    /* padding-top: 40px; */
    z-index: 10;
    /* background-color: rgba(31, 201, 96, 0.3); */
    background: #6d9eeb;
    opacity: 0.7;
    position: relative;
    top: 0px;
    left: 0px;
    height: 54px;
    overflow: hidden;
    // margin: 2px;
    border-radius: 5px;
  }

  .meetsShow {
    position: absolute;
    width: 100%;
    bottom: 0px;
    left: 0px;
    height: 30px;
    line-height: 30px;
    color: #f7f6f6;
    .meet-item {
      height: 15px !important;
      line-height: 14px !important;
      font-size: 12px;
      width: 110%;
      padding: 0 4px;
      margin-left: -6%;
      transform: scale(0.9);
      &:hover {
        color: #050505;
      }
    }
  }

  .font14 {
    font-size: 14px;
  }

  .more {
    color: rgb(209, 93, 93);
    font-size: 14px;
    float: right;
    line-height: 20px;
    cursor: pointer;
  }

  .top .el-col div {
    height: 120px;
  }
</style>
<style lang="scss">
  .el-calendar__button-group {
    display: none;
  }
  #homePage {
    display: flex;
    flex-direction: column;
    .header {
      display: flex;
      height: 320px;
      .carousel {
        flex: 1;
      }
      .todyMeets {
        margin-left: 20px;
        width: 400px;
      }
    }
    .content {
      flex: 1;
      min-height: 400px;
      .dataSelect {
        display: flex;
        .radio {
          width: 140px;
        }
        .picker {
          width: 150px;
        }
        .depart, .user, .btn {
          margin-left: 10px;
          .title {
            font-size: 14px;
            color: #606266;
          }
        }
      }
      .calendarPanel {
        .el-carousel__arrow--left {
          left: 10px !important;
        }
        .el-carousel__arrow--right {
          right: 10px !important;
        }
        .el-calendar__header {
          padding: 10px 0;
          .el-calendar__title {
            color: #606266;
            text-align: center;
            flex: 1;
            font-weight: bold;
          }
        }
        .el-carousel__container {
          height: 440px;
          .el-carousel__arrow {
            font-size: 16px;
            background-color: #999a9b;
            opacity: 0.8;
            &:hover {
              opacity: 1;
              background-color: #6d9eeb;
            }
          }
        }
        .el-calendar-table {
          thead th {
            padding: 8px 0 !important;
            font-size: 14px;
          }
        }
        .carouselItem {
          height: 430px;
          display: flex;
          padding: 15px;
          .calendar {
            flex: 1;
            margin-right: 20px;
            border: 1px solid #afacac;
            border-radius: 6px;
            overflow: hidden;
            &:last-child {
              margin-right: 0;
            }
            &.isNow {
              border-color: #6d9eeb;
            }
            .nowMonth {
              // background-color: #ecebec;
              .el-calendar__header {
                border-bottom-color: #6d9eeb;
                background-color: #6d9eeb;
              }
              .el-calendar__title {
                color: #ffffff;
              }
            }
          }
        }
        .el-calendar__body {
          padding: 0 !important;
        }
        // overflow-x: auto;
        // margin-top: 20px;
        // .calendar {
        //   width: 400px;
        //   float: left;
        //   margin-right: 20px;
        //   &:last-child {
        //     margin-right: 0;
        //   }
        // }
      }
    }
  }

  /* #homePage {
    min-width: 1100px;
    overflow-x: auto;
  } */
  #homePage .el-calendar-table .el-calendar-day {
    height: 54px;
    overflow: hidden;
    padding: 0;
  }

  #homePage .el-calendar-table .el-calendar-day p {
    line-height: 22px;
    height: 22px;
    margin: 0px 0 0 0;
    vertical-align: middle;
  }

  #homePage .el-card__header {
    padding: 10px;
  }

  // .el-calendar__body {
  //   padding: 15px 20px;
  // }
</style>
